import React from 'react';
import PropTypes from 'prop-types';

function Share({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M3.65 18.124c0 .043.014.086.042.124a.25.25 0 00.123.087h.001a.27.27 0 00.162.003.247.247 0 00.124-.084h0l.006-.007c.155-.193 2.853-3.507 8.033-3.507.232 0 .467.006.704.02a.75.75 0 01.705.749v2.617c0 .04.012.08.037.117a.244.244 0 00.11.088c.049.019.102.024.154.014a.257.257 0 00.131-.067l.001-.002 6.3-6.124h0a.221.221 0 00.05-.073.202.202 0 000-.16.222.222 0 00-.05-.072h0l-6.3-6.125a.259.259 0 00-.131-.067.274.274 0 00-.154.015.245.245 0 00-.11.087.208.208 0 00-.038.118s0 0 0 0v2.58a.748.748 0 01-.677.747c-1.305.123-3.636.527-5.623 1.817-1.948 1.265-3.6 3.396-3.6 7.105zm0 0H3h.65z" />
    </svg>
  );
}

Share.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Share;
